export default reports => reports.map(report => ({
  value: report.module,
  label: `${report.reportName}`,
}));
